// ─── FilterTabs.jsx ────────────────────────────────────────────────────────
const FilterTabs = ({ activeTab, theme, onSelect }) => (
  <div className="s-flex s-items-center s-py-7px s-rounded-5px s-text-11px s-bg-filter-background-light dark:s-bg-filter-background-dark dark:s-text-global-font-default-dark s-shadow-2sm">
    {[
      { key: "today", label: "Today" },
      { key: "active", label: "Tomorrow" },
    ].map(({ key, label }, i) => (
      <div
        key={key}
        onClick={() => onSelect(key)}
        className={`s-px-7px s-flex s-items-center cursor-pointer s-text-gray-500 ${i === 0 ? "s-border-r s-border-r-black-300 dark:s-border-r-black dark:s-border-s-opacity-30" : ""}`}
      >
        {activeTab === key && (
          <i style={{ color: "#21b889" }} className="s-icon-check-circle s-text-11px s-mr-3px s-text-main-menu-text-active" />
        )}
        <span style={theme === "light" ? { color: "white" } : {}} className="s-text-14px">
          {label}
        </span>
      </div>
    ))}
  </div>
);

export default FilterTabs;